import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import PhoneField from '../FormLegacy/FormFieldsV2/PhoneField'

import { validateUSPhoneNumber } from './helper'

const EmergencyPhoneField = ({ phoneNumber = '', handleChange }) => {
  const { t } = useTranslation(['on-call-schedule'])
  const [value, setValue] = useState(phoneNumber)
  const [isValid, setValid] = useState(true)

  return (
    <PhoneField
      type="tel"
      value={value}
      onChange={(e) => {
        const input = e.target.value
        setValue(input)
        if (validateUSPhoneNumber(input)) {
          handleChange(input)
          setValid(true)
        } else {
          setValid(false)
        }
      }}
      isError={!isValid && Boolean(value)}
      errorLabel={t('on-call-schedule:emergencyPhoneField.errorLabel')}
      placeholder={t('on-call-schedule:emergencyPhoneField.placeholder')}
    />
  )
}

EmergencyPhoneField.propTypes = {
  phoneNumber: PropTypes.string,
  handleChange: PropTypes.func,
}
export default EmergencyPhoneField
